export const timeToShowAiReminderModal = 12 * 60 * 60 * 1000; // 12 hours in milliseconds

export const reminderModalVariants = [
  'tutor.reminderModal.variant.0',
  'tutor.reminderModal.variant.1',
  'tutor.reminderModal.variant.2',
  'tutor.reminderModal.variant.3',
  'tutor.reminderModal.variant.4',
  'tutor.reminderModal.variant.5',
  'tutor.reminderModal.variant.6',
  'tutor.reminderModal.variant.7',
  'tutor.reminderModal.variant.8',
  'tutor.reminderModal.variant.9',
  'tutor.reminderModal.variant.10',
  'tutor.reminderModal.variant.11',
  'tutor.reminderModal.variant.12',
  'tutor.reminderModal.variant.13',
  'tutor.reminderModal.variant.14',
  'tutor.reminderModal.variant.15',
  'tutor.reminderModal.variant.16',
  'tutor.reminderModal.variant.17',
  'tutor.reminderModal.variant.18',
  'tutor.reminderModal.variant.19',
  'tutor.reminderModal.variant.20',
  'tutor.reminderModal.variant.21',
  'tutor.reminderModal.variant.22',
  'tutor.reminderModal.variant.23',
  'tutor.reminderModal.variant.24',
  'tutor.reminderModal.variant.25',
  'tutor.reminderModal.variant.26',
  'tutor.reminderModal.variant.27',
  'tutor.reminderModal.variant.28',
  'tutor.reminderModal.variant.29',
  'tutor.reminderModal.variant.30',
  'tutor.reminderModal.variant.31',
  'tutor.reminderModal.variant.32',
  'tutor.reminderModal.variant.33',
  'tutor.reminderModal.variant.34',
  'tutor.reminderModal.variant.35',
  'tutor.reminderModal.variant.36',
  'tutor.reminderModal.variant.37',
  'tutor.reminderModal.variant.38',
  'tutor.reminderModal.variant.39',
  'tutor.reminderModal.variant.40',
  'tutor.reminderModal.variant.41',
  'tutor.reminderModal.variant.42',
  'tutor.reminderModal.variant.43',
  'tutor.reminderModal.variant.44',
  'tutor.reminderModal.variant.45',
  'tutor.reminderModal.variant.46',
  'tutor.reminderModal.variant.47',
  'tutor.reminderModal.variant.48',
  'tutor.reminderModal.variant.49',
  'tutor.reminderModal.variant.50',
  'tutor.reminderModal.variant.51',
  'tutor.reminderModal.variant.52',
  'tutor.reminderModal.variant.53',
  'tutor.reminderModal.variant.54',
  'tutor.reminderModal.variant.55',
  'tutor.reminderModal.variant.56',
  'tutor.reminderModal.variant.57',
  'tutor.reminderModal.variant.58',
];
